<template>
    <div class="all">
      <my-title :msg="title"></my-title>
      <div class="focusoncommodities_bot" style="display: none">
        <button style="background: #ff957b;" :class="ommodities == 0?'button_ca':''" @click="ommodities = 0">我的足迹</button>
        <button style="background: #50bdde;" :class="ommodities !== 0?'button_ca':''" @click="ommodities = 1">我的收藏</button>
      </div>
      <div class="focusoncommodities_bot_onw" v-if="ommodities == 0">
        <div class="focusoncommodities_bot_onw_for Changgou" v-for="i in 5">
          <div class="focusoncommodities_bot_onw_for_img">
            <img src="../assets/service_items_2.jpg" alt="">
          </div>
          <div class="focusoncommodities_bot_onw_for_text">
            <span>佳能 IP8780 A3+双网络无线喷墨照片打印机 黑色 计价单位:台</span>
          </div>
          <div class="focusoncommodities_bot_onw_for_shop">
            <div class="focusoncommodities_bot_onw_for_shop_left">
              <span>￥2615</span>
            </div>
            <div class="focusoncommodities_bot_onw_for_shop_right">
              <span></span>
              加入购物车
            </div>
            <div class="clear"></div>
          </div>
          <span class="Changgou_pos">购买2次</span>
        </div>
      </div>
      <div class="focusoncommodities_bot_two" v-else>
        <div class="focusoncommodities_bot_onw_for Shoucang" v-for="(item,i) in List" :key="i">
          <div class="focusoncommodities_bot_onw_for_img" @click="$router.push({path:'/details',query:{id:item.id}})">
            <img :src="$store.state.Url+item.goods_img" alt="">
          </div>
          <div class="focusoncommodities_bot_onw_for_text" @click="$router.push({path:'/details',query:{id:item.id}})">
            <span>{{item.name}}</span>
          </div>
          <div class="focusoncommodities_bot_onw_for_shop">
            <div class="focusoncommodities_bot_onw_for_shop_left">
              <span>{{item.price}}</span>
            </div>
            <div class="focusoncommodities_bot_onw_for_shop_right" @click="getAddShopIng(item.id)">
              <span></span>
              加入购物车
            </div>
            <div class="clear"></div>
          </div>
          <span class="Shoucang_pos">收藏商品</span>
        </div>
      </div>
    </div>
</template>

<script>
  import {getquerycollection} from '../api/Mycen'
  import {getshopping} from '../api/List'
    export default {
        name: "focusoncommodities",
      data(){
        return{
          ommodities:1,
          title:'收藏商品',
          List:[],
        }
      },
      mounted() {

          // console.log("引入")
        this.init()
      },
      methods:{
        init(){
          getquerycollection({}).then(res=>{
            this.List = res.result
          })
        },
        getAddShopIng(id){
          getshopping({goods_id:id,num:1}).then(res=>{
            this.$router.push({path:'/ShoppingCart'})
          })
        }
      }
    }
</script>

<style scoped lang="less">
  @import "css/focusoncommodities";
  .focusoncommodities_bot_onw{
    height: 790px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/focusoncommodities.vue